import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Reveal } from '../Reveal';

const FinalCTA = () => (
  <section className="relative overflow-hidden bg-navy py-24 md:py-36" data-testid="final-cta-section">
    <div className="bg-grid-dark absolute inset-0" />
    <div className="absolute -left-32 top-0 h-96 w-96 rounded-full bg-coral/15 blur-3xl" />
    <div className="absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-coral/10 blur-3xl" />

    <div className="relative mx-auto max-w-5xl px-6 text-center md:px-12">
      <Reveal>
        <h2 className="font-display text-4xl font-extrabold tracking-tighter text-white sm:text-5xl lg:text-6xl" data-testid="final-cta-headline">
          Your Career Doesn't Need More Confusion.
          <span className="text-brand-gradient mt-2 block">It Needs the Right Direction.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.12}>
        <p className="mx-auto mt-7 max-w-xl text-base text-white/70 md:text-lg">
          Start building your career with clarity today.
        </p>
      </Reveal>
      <Reveal delay={0.22}>
        <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            to="/book-consultation"
            data-testid="final-book-consultation-cta"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-coral px-8 py-4 text-base font-semibold text-white transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-coral-deep"
          >
            Book a Consultation <ArrowRight className="h-4 w-4" />
          </Link>
          <Link
            to="/career-paths"
            data-testid="final-explore-paths-cta"
            className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/20 px-8 py-4 text-base font-semibold text-white transition-[border-color,background-color,transform] duration-200 hover:-translate-y-0.5 hover:border-white hover:bg-white/5"
          >
            Explore Career Paths
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FinalCTA;
